<template>
  <div>
    <PageAppBar>New Prayer Request</PageAppBar>
    <div class="page-content header-clear-small">
      <div class="card card-style" style="position: relative">
        <div class="login-box">
          <div class="textbox">
            <input type="text" placeholder="Enter Prayer Request" v-model="title" required>
          </div>

          <div class="textbox">
            <input type="text" placeholder="Prayer Description" v-model="body" required>
            <!-- <textarea type="text" name="" id="" cols="30" rows="5" placeholder="Prayer Description" v-model="body" required></textarea> -->
          </div>

          <input class="btn font-900 shadow-s" type="button" name="" value="Send" @click="savePrayer">
        </div>
          

      </div>
    </div>
    <FooterBar></FooterBar>
  </div>
</template>

<script>
import global from "@/mixins/global";
import PageAppBar from "@/components/PageAppBar";
import FooterBar from "@/components/FooterBar";
import axios from "axios";
export default {
  mixins: [global],
  name: "NewPrayer",
    components: {FooterBar, PageAppBar},
  data(){
    return {
      title: "",
      body: ""
    }
  },
  methods: {
    savePrayer(){
      axios.post(this.base_url+ "prayers", {
        
        title: this.title,
        body: this.body
      }, this.requestAuthHeaderToken(localStorage.getItem("token")))
          .then(response => {
            console.log(response)
            if (Object.keys(response).length) {
              this.$router.back()
            }
          }).catch(error => {
        this.error = error
      })
    }
  }
  }
</script>

<style scoped>


.textbox{

  width: 100%;
  overflow: hidden;
  padding: 8px 0;
  margin: 8px 0;
  border-bottom: 1px solid #DA4453;
}

.textbox input, textarea {
  border: none;
  background: none;
  outline: none;
  width: 80%;
  font-size: 18px;
  
  margin:  0 10px;
}
.btn{
  width: 100%;
  background-color: #DA4453;
  border: 2px solid #DA4453; ;
  margin: 12px 0;
  padding: 5px;
  border-radius: 5px;
  color: white;
  font-size: 18px!important;


}
textarea{
  color: white;
}
.login-box{

  width: 90%;
  /* position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%); */
  margin: 0 auto;
  font-family: sans-serif;
}
::-webkit-input-placeholder { /* Chrome/Opera/Safari */
  font-size: 15px!important;
}
::-moz-placeholder { /* Firefox 19+ */
   font-size: 15px!important;
}
:-ms-input-placeholder { /* IE 10+ */
   font-size: 15px!important;
}
:-moz-placeholder { /* Firefox 18- */
   font-size: 15px!important;
}

</style>